export default function convert(img) {
  if (!img) {
    return "";
  }
  const num = img.indexOf("_");
  return img.substring(num + 1).slice(0, -4);
}
